import { dataArrowRight } from 'dls-icons-data'
import { createIcon } from '../common'

const IconArrowRight = /*#__PURE__*/createIcon(dataArrowRight)
export default IconArrowRight
